// removed by extract-text-webpack-plugin
module.exports = {"linkBlue":"#0076C0","borderGray":"#d9d9d9","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","container":"container-3RFrf","closeButton":"closeButton-1N4hw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/_authModal.css
// module id = 1182
// module chunks = 1